/**
 * Create-session panel for sessions.
 */
import { FC } from 'react';
import { InformationMeetingForm } from './session-form-builder/InformationMeetingForm';
import { TutoringSessionForm } from './session-form-builder/TutoringSessionForm';
import type {
  PlanificationType,
  SessionFormKind,
  SessionGroup,
} from '@/types/inperson/session.types';

/** Props for {@link CreateSessionView}. */
interface CreateSessionViewProps {
  kind?: SessionFormKind;
  onClose: () => void;
  onSuccess?: () => void;
  className?: string;
  showParticipants?: boolean;
  /** Restricts session-type options to the planification type chosen upstream. */
  planificationType?: PlanificationType;
  /**
   * Edit-group mode: prefilled from the parent session group and
   * submits PATCH /session-groups/:id (shared metadata + child reconciliation).
   */
  editGroup?: SessionGroup;
  onRequestCreateTutor?: () => void;
}

/** Create-session panel for sessions. */
export const CreateSessionView: FC<CreateSessionViewProps> = ({
  kind = 'tutoring_session',
  onClose,
  onSuccess,
  className,
  showParticipants = true,
  planificationType,
  editGroup,
  onRequestCreateTutor,
}) => {
  if (kind === 'information_meeting') {
    return (
      <InformationMeetingForm mode="create" onClose={onClose} onSuccess={() => onSuccess?.()} />
    );
  }

  return (
    <TutoringSessionForm
      mode="create"
      planificationType={planificationType}
      editGroup={editGroup}
      showParticipants={showParticipants}
      onClose={onClose}
      onSuccess={onSuccess}
      className={className}
      onRequestCreateTutor={onRequestCreateTutor}
    />
  );
};
